import { render, staticRenderFns } from "./ReportPdfGeneration_new.vue?vue&type=template&id=4f374da0&"
import script from "./ReportPdfGeneration_new.vue?vue&type=script&lang=js&"
export * from "./ReportPdfGeneration_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports